import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/layout/Logo";
import ThemeToggle from "@/components/widgets/ThemeToggle";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("If that email exists, we've sent a reset link.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Could not send reset link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-between mb-8">
          <Logo />
          <ThemeToggle />
        </div>
        <div className="rounded-2xl glass p-8">
          <h1 className="font-display text-3xl mb-2">Reset your password</h1>
          <p className="text-sm text-muted-foreground mb-6">Enter the email associated with your account. We'll send you a secure reset link.</p>
          {done ? (
            <div className="text-sm space-y-3">
              <p>Check your inbox for the reset link. If you don't see it in 5 minutes, please check spam.</p>
              <Link to="/login" className="text-primary">Back to sign in</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <Button type="submit" disabled={loading} className="w-full brand-gradient text-white rounded-full h-11" data-testid="forgot-submit">{loading ? "Sending..." : "Send reset link"}</Button>
              <div className="text-sm text-muted-foreground text-center">Remembered your password? <Link to="/login" className="text-primary">Sign in</Link></div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
